export const REQUIRED_FIELDS = "REQUIRED_FIELDS";

export const requiredFieldsError = (fields) => ({
  type: REQUIRED_FIELDS,
  payload: fields,
});
